import { useAuth0 } from "@auth0/auth0-react";
import { microsoftButton } from "./MicrosoftLoginButton.css";

function MicrosoftLogo() {
  return (
    <svg width="21" height="22" viewBox="0 0 21 22" fill="none">
      <path d="M10 1.5H1V10.5H10V1.5Z" fill="#F25022" />
      <path d="M10 11.5H1V20.5H10V11.5Z" fill="#00A4EF" />
      <path d="M20 1.5H11V10.5H20V1.5Z" fill="#7FBA00" />
      <path d="M20 11.5H11V20.5H20V11.5Z" fill="#FFB900" />
    </svg>
  );
}

/**
 * Button component for Microsoft login.
 * It uses the `login` function to initiate the login process when clicked.
 */

export function MicrosoftLoginButton() {
  const { loginWithRedirect } = useAuth0();

  return (
    <button
      className={microsoftButton}
      onClick={() => {
        loginWithRedirect({
          authorizationParams: {
            connection: "microsoft"
          }
        });
      }}
    >
      <MicrosoftLogo />
      Log in with Microsoft
    </button>
  );
}
